import React from 'react';
import {Container} from './style'
// import { Container } from './styles';

function Page404() {
  return (
      <Container>
         PAGINA NÃO ENCONTRADA
      </Container>
  );
}

export default Page404;